import PropTypes from 'prop-types';

import { Card, Layout } from '@utilities';

import {
  answerOperators,
  disqualifyOperators,
} from '../../../../../QuestionLogic/utilities/constants';
import DisqualifyLogicRow from '../../../../../QuestionLogic/components/DisqualifyLogicRow';
import OptionLogicRow from '../../../Question/components/ModalAnswerOptionLogic/components/OptionLogic/components/OptionLogicRow';
import QuestionLogicOptions from '../../../../../QuestionLogic/components/QuestionLogicOptions';
import SkipLogicRow from '../../../../../QuestionLogic/components/SkipLogicRow';

const QuestionLogicCondition = ({ answerId, question, questionLogic, selectedQuestions, type }) => {
  const disqualifyLogic = questionLogic[question.id]?.disqualify;
  const logicList =
    type === 'option'
      ? questionLogic?.[question.id]?.option?.[answerId]?.logic || []
      : questionLogic?.[question.id]?.skip?.logic || [];
  // only show skip logic that references questions below the current question
  const logicIndexes = logicList.reduce((acc, logicItem, index) => {
    if (!selectedQuestions || !question) return acc;

    const currentQuestionIndex = selectedQuestions.findIndex(({ id }) => id === question.id);
    const logicQuestionId = logicItem?.question?.id;
    const logicQuestionIndex = selectedQuestions.findIndex(({ id }) => id === logicQuestionId);
    if (logicQuestionIndex > currentQuestionIndex) acc.push(index);
    return acc;
  }, []);

  return (
    <Card>
      <h4>Condition</h4>
      <Layout.Flex.Column gap="small">
        {type === 'disqualify' && (
          <div>
            {Array.isArray(disqualifyLogic?.logic) ? (
              <>
                <span>Disqualify if&nbsp;</span>
                <QuestionLogicOptions
                  isCompleted
                  options={disqualifyOperators}
                  optionsType="radio"
                  value={disqualifyLogic.operator}
                />
                <span>&nbsp;apply</span>
                {(disqualifyLogic.logic || []).map((_, index) => (
                  <DisqualifyLogicRow
                    index={index}
                    isCompleted
                    key={index}
                    question={question}
                    questionId={question.id}
                    questionLogic={questionLogic}
                    setQuestionLogic={() => {}}
                  />
                ))}
              </>
            ) : (
              <>
                <span>Disqualify if the answer is&nbsp;</span>
                <QuestionLogicOptions
                  isCompleted
                  options={answerOperators}
                  optionsType="radio"
                  value={disqualifyLogic.operator}
                />
                <span>:&nbsp;</span>
                <QuestionLogicOptions
                  isCompleted
                  options={question.answers}
                  optionsType="checkbox"
                  value={disqualifyLogic.answers}
                />
              </>
            )}
          </div>
        )}
        {type === 'option' &&
          logicIndexes.map((index) => (
            <OptionLogicRow
              answerId={Number(answerId)}
              index={index}
              isCompleted
              key={index}
              questionId={question.id}
              questionIndex={selectedQuestions?.findIndex(({ id }) => id === question.id)}
              questionList={selectedQuestions}
              questionLogic={questionLogic}
              setQuestionLogic={() => {}}
            />
          ))}
        {type === 'skip' &&
          logicIndexes.map((index) => (
            <SkipLogicRow
              index={index}
              isCompleted
              key={index}
              questionId={question.id}
              questionList={selectedQuestions}
              questionLogic={questionLogic}
            />
          ))}
      </Layout.Flex.Column>
    </Card>
  );
};

QuestionLogicCondition.propTypes = {
  answerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  question: PropTypes.object.isRequired,
  questionLogic: PropTypes.object.isRequired,
  selectedQuestions: PropTypes.array,
  type: PropTypes.oneOf(['disqualify', 'option', 'skip']).isRequired,
};

export default QuestionLogicCondition;
